__turbopack_context__.v({
  "applicationLoader": "LandingFormMBA-module-scss-module__Ntq_QG__applicationLoader",
  "authorization": "LandingFormMBA-module-scss-module__Ntq_QG__authorization",
  "checkboxWrapper": "LandingFormMBA-module-scss-module__Ntq_QG__checkboxWrapper",
  "commonMargins": "LandingFormMBA-module-scss-module__Ntq_QG__commonMargins",
  "customBackground": "LandingFormMBA-module-scss-module__Ntq_QG__customBackground",
  "emailContainer": "LandingFormMBA-module-scss-module__Ntq_QG__emailContainer",
  "error": "LandingFormMBA-module-scss-module__Ntq_QG__error",
  "errorMessage": "LandingFormMBA-module-scss-module__Ntq_QG__errorMessage",
  "formHeading": "LandingFormMBA-module-scss-module__Ntq_QG__formHeading",
  "formWrapper": "LandingFormMBA-module-scss-module__Ntq_QG__formWrapper",
  "greyBackground": "LandingFormMBA-module-scss-module__Ntq_QG__greyBackground",
  "inputWrapper": "LandingFormMBA-module-scss-module__Ntq_QG__inputWrapper",
  "newLeadFormEmail": "LandingFormMBA-module-scss-module__Ntq_QG__newLeadFormEmail",
  "newLeadFormEmailFullWidth": "LandingFormMBA-module-scss-module__Ntq_QG__newLeadFormEmailFullWidth",
  "newLeadFormFirstName": "LandingFormMBA-module-scss-module__Ntq_QG__newLeadFormFirstName",
  "newLeadFormPhone": "LandingFormMBA-module-scss-module__Ntq_QG__newLeadFormPhone",
  "newLeadFormWrapper": "LandingFormMBA-module-scss-module__Ntq_QG__newLeadFormWrapper",
  "root": "LandingFormMBA-module-scss-module__Ntq_QG__root",
  "whiteBackground": "LandingFormMBA-module-scss-module__Ntq_QG__whiteBackground",
  "widthInputbox": "LandingFormMBA-module-scss-module__Ntq_QG__widthInputbox",
});
